import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const LotTableSettingsColumn = {
  lotNumber: 'lotNumber',
  productName: 'productName',
  productNumber: 'productNumber',
  lotExpiry: 'lotExpiry',
} as const;

export type LotTableSettingsColumn = (typeof LotTableSettingsColumn)[keyof typeof LotTableSettingsColumn];

export class LotTableSettings {
  static default(companyId: string) {
    return new TableSettings<LotTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.lot,
      columns: [
        {
          index: 0,
          column: LotTableSettingsColumn.lotNumber,
          label: translate({ key: LotTableSettingsColumn.lotNumber }),
        },
        {
          index: 1,
          column: LotTableSettingsColumn.productName,
          label: translate({ key: LotTableSettingsColumn.productName }),
        },
        {
          index: 2,
          column: LotTableSettingsColumn.productNumber,
          label: translate({ key: LotTableSettingsColumn.productNumber }),
        },
        {
          index: 3,
          column: LotTableSettingsColumn.lotExpiry,
          label: translate({ key: LotTableSettingsColumn.lotExpiry }),
        },
      ],
    });
  }
}
